import { createSlice } from "@reduxjs/toolkit";

const typeListSlice = createSlice({
    name : "type",
    initialState:{

        list: []
    },
    reducers:{
        createtypenamelist (state, action){
            console.log(action)
            // state.list.push([...state, action.payload])
            state.list =  action.payload
            // console.log(` Inside the store ${state.list}`)
        }
    }

})

export const typeListActions = typeListSlice.actions
export default typeListSlice